import { render, staticRenderFns } from "./LiveGoodsData.vue?vue&type=template&id=1a2e9b74&scoped=true"
import script from "./LiveGoodsData.vue?vue&type=script&lang=js"
export * from "./LiveGoodsData.vue?vue&type=script&lang=js"
import style0 from "./LiveGoodsData.vue?vue&type=style&index=0&id=1a2e9b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e9b74",
  null
  
)

export default component.exports